<template lang="pug">
div(
    @click="clickClose"
    @touchstart="showMenu"
    @mouseenter="showMenu"
    @mouseleave="closeMainMenu"
    v-bind="rootOptions"
)
    //- Category
    slot(:isMenuOpen="isMenuOpen")

    //- Tree or text
    client-only
        template(v-if="wrapperOptions.is")
            transition(name="fade" @after-leave="isMenuActive=false")
                //- isMenuOpen Controls Show/Hide of the total menu
                //- isMenuActive Delays the hiding of children until after Fade Animation
                component(
                    v-show="isMenuOpen"
                    v-bind="wrapperOptions"
                    :data="data"
                    :isActive="isMenuActive"
                )
</template>

<script>
import { bindStoryblokBridgeData, getUniversalLinkTarget } from '../../../helpers'
import TreeMenu from './treeMenu'
import LinkMenu from './linkMenu'
import CmsMenu from './cmsMenu'

export default {
    name: 'NavItem',
    components: { TreeMenu, LinkMenu, CmsMenu },
    props: {
        data: {
            type: Object,
            default() {
                return {}
            },
        },
    },
    data() {
        return {
            isMenuActive: false,
            isMenuOpen: false,
        }
    },
    computed: {
        rootOptions() {
            return bindStoryblokBridgeData(this.data)
        },
        wrapperOptions() {
            const options = {
                is: null,
            }

            switch (this.data.component) {
                case 'tree-menu':
                    if (this.data.items) options.is = TreeMenu
                    break
                case 'link-menu':
                    if (this.data.items) options.is = LinkMenu
                    break
                case 'cms-menu':
                    if (this.data.sections) options.is = CmsMenu
                    break
            }

            return options
        },
    },
    methods: {
        getUniversalLinkTarget,
        clickClose(event) {
            if (this.$storyblok.isEditing && this.$sitewideData.isNavbarPreview) return

            // Make sure this event is a Universal Link
            const target = this.getUniversalLinkTarget(event)
            if (!target) return

            // We know its a universal link, but it may not have an href
            // Ex: ACCOUNT triggers
            const link = target.href ? { link: target.href } : { text: target.innerText }

            // Get the level from the dataset
            const { level } = target.dataset

            // Emit the event
            this.$uiEvents.$emit('navigationClicked', {
                ...link,
                ...(level && { level }),
                ...(level && { level }),
                ...(this.data.text && { rootText: this.data.text }),
            })

            // CLOSE THE MENU
            this.closeMainMenu()
        },
        closeMainMenu() {
            clearTimeout(this.navHoverTimer)

            this.isMenuOpen = false
        },
        showMenu() {
            clearTimeout(this.navHoverTimer)

            this.navHoverTimer = setTimeout(() => {
                this.isMenuActive = true
                this.isMenuOpen = true
            }, 175)
        },
    },
}
</script>
